import { EveRoutes } from '@ver-uds/e-verify';
import React, { ReactNode } from 'react';
import { SkipNav } from '@ver-uds/uswds-react';
import Feature from '../../../constants/Feature';
import EveSideNav, { SideNavItems } from './EveSideNav/EveSideNav';
import './Container.scss';
import I9Constants from '../../I9Constants/I9Constants';

interface ContainerProps {
  children: ReactNode;
  content: Feature;
  showTraining: boolean;
}

const sideNavItems: (showTraining: boolean) => SideNavItems[] = (showTraining) => [
  { href: EveRoutes.RESOURCES_VIEW, text: 'View Essential Resources', feature: Feature.FEATURE_VIEW_RESOURCES },
  { href: EveRoutes.TUTORIAL, text: 'Take Tutorial', feature: Feature.FEATURE_TUTORIAL },
  ...(showTraining
    ? [
        {
          href: EveRoutes.RESOURCES_VIEW_TRAINING,
          text: `View ${I9Constants.PROGRAM_NAME} Training`,
          feature: Feature.FEATURE_VIEW_TRAINING,
        },
      ]
    : []),
  { href: EveRoutes.RESOURCES_MANUAL, text: 'View User Manual', feature: Feature.FEATURE_VIEW_MANUAL },
  { href: EveRoutes.RESOURCES_NEWS, text: 'E-Verify News and Announcements', feature: Feature.FEATURE_NEWS },
  { href: EveRoutes.RESOURCES_CONTACT_US, text: 'Contact Us', feature: Feature.FEATURE_CONTACT_US },
];

const Container = ({ children, content, showTraining }: ContainerProps): JSX.Element => {
  return (
    <div className="grid-container">
      <div className="grid-row">
        <div className="desktop:grid-col-3 tablet-lg:grid-col-3 nav-container">
          <EveSideNav currentFeature={content} sideNavItems={sideNavItems(showTraining)} />
        </div>
        <div className="desktop:grid-col-9 tablet-lg:grid-col-9 tablet:grid-col-12 content-container">
          <SkipNav.MainContent>{children}</SkipNav.MainContent>
        </div>
      </div>
    </div>
  );
};

export default Container;
